// src/app/state/cart.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { loadPaintersSuccess, addPainters, removePainter } from './painters.actions';
import { IPainters } from '@interfaces';

export interface PaintersState {
  painters: IPainters[];
}

export const initialState: PaintersState = {
  painters: [],
};

const _painterReducer = createReducer(
  initialState,
  on(loadPaintersSuccess, (state, { painters }) => ({ ...state, painters })),
  on(addPainters, (state, { painters }) => ({
    ...state,
    painters: [...state.painters, ...painters], // Add multiple painters
  })),
  on(removePainter, (state, { painterId }) => ({
    ...state,
    painters: state.painters.filter((painter) => painter.id !== painterId),
  })),
);

export function painterReducer(state: PaintersState | undefined, action: any) {
  return _painterReducer(state, action);
}
